import type {GetExamsAuthorizedPassword} from 'domain/usecases/private/booking-flow/exams/get-exams-authorized-password';
import {RemoteGetExamsAuthorizedPassword} from 'data/usecases/private/booking-flow/exams/remote-get-exams-authorized-password';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';
import {getFeatureFlagValue} from 'infra/http/utils/get-feature-flag-value';
import {FeaturesEnum} from 'presentation/constants';

export const makeGetExamsAuthorizedPassword = (): GetExamsAuthorizedPassword => {
	const isExamsPasswordV3Enabled = getFeatureFlagValue(
		FeaturesEnum.PORTAL_FEATURE_EXAMS_PASSWORD_V3,
	);

	const endpoint = isExamsPasswordV3Enabled
		? BookingFlowEndPoints.examAuthorizedPasswordV3
		: BookingFlowEndPoints.examAuthorizedPassword;

	return new RemoteGetExamsAuthorizedPassword(
		makeBFFApiUrl(endpoint),
		makeAuthorizeHttpClientDecorator(),
	);
};
